export class SaleCustomCostcodeTransactionModel {
  transactionSurrKey: number;
  createDate: Date;
  transactionCode: string;
  companyName: string;
  productName: string;
  amount: number;
  paymentMethod: number;
  userName: string;
  userPhone: string;
  userEmail: string;
  paidDate: Date;
  orderInvoiceSurrKey?: number;
  isInvoiceActive: boolean;
  refOrder?: string;
  orderStatus: number;
}

export class SaleCustomCostcodeTransactionListModel {
  itemList: Array<SaleCustomCostcodeTransactionModel>;
  pageNumber: number;
  pageSize: number;
  totalItemCount: number;
  totalPageCount: number;
}

export class SaleCustomCostcodeTransactionListQueryModel {
  textSearch?: string;
  pageNumber: number;
  pageSize: number;
  sortColumn?: string;
  sortByDesc: boolean;
  status?: number;
  startDate?: Date;
  endDate?: Date;
}
